export function getPathSegmentByIndex(path: string, index: number) {
  return path.replace(/^\//, "").split("/")[index] || "";
}
